import { makeImmutable } from "../../core";
export class CrossSellingList {
    constructor(params) {
        this.id = params.id;
        this.items = params.items;
        makeImmutable(this);
    }
}
